import script from "./VueFullpage.vue?vue&type=script&setup=true&lang=js"
export * from "./VueFullpage.vue?vue&type=script&setup=true&lang=js"

import "./VueFullpage.vue?vue&type=style&index=0&id=38cd1944&lang=scss"

const __exports__ = script;

export default __exports__